export default __webpack_public_path__ + "static/media/criteria-3.7b0ded5f.jpg";